/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, TextField } from "@mui/material";
import { Vocabulary } from "../../../Utils/Vocabulary";
import GenericModal from "../../GenericComponents/GenericModal";
import { EditModalProps } from "./ProductVariants";

type EditMultipleVariantsProps = {
  editModal: EditModalProps;
  handleEditModal: (editModal: EditModalProps) => void;
  handleEditVariantInformation: () => void;
};

export default function EditMultipleVariants(props: EditMultipleVariantsProps) {
  const { editModal, handleEditModal, handleEditVariantInformation } = props;
  return (
    <GenericModal
      open={editModal.openModal}
      onClose={() =>
        handleEditModal({
          openModal: false,
          pricePerQuantity: 0,
          totalPrice: 0,
          quantity: 0,
        })
      }
      title={Vocabulary.editPriceOrQuantity}
      actions={
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            padding: 20,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ color: "white" }}
            onClick={() =>
              handleEditModal({
                openModal: false,
                pricePerQuantity: 0,
                totalPrice: 0,
                quantity: 0,
              })
            }
          >
            {Vocabulary.no}
          </Button>
          <Button
            variant="contained"
            style={{ color: "white" }}
            onClick={() => {
              handleEditModal({
                openModal: false,
                pricePerQuantity: 0,
                totalPrice: 0,
                quantity: 0,
              });
              handleEditVariantInformation();
            }}
          >
            {Vocabulary.yes}
          </Button>
        </div>
      }
      style={{ zIndex: 1500, textAlign: "center" }}
    >
      <TextField
        type="number"
        size="small"
        name="quantity"
        label={Vocabulary.editQuantity}
        value={editModal.quantity}
        onChange={(e: any) => {
          handleEditModal({
            ...editModal,
            quantity: +e.target.value || 0,
            totalPrice: +e.target.value * editModal.pricePerQuantity || 0,
          });
        }}
        fullWidth
        style={{ marginTop: 10 }}
      />
      <TextField
        type="number"
        size="small"
        name="pricePerQuantity"
        label={Vocabulary.pricePerQuantity}
        value={editModal.pricePerQuantity}
        onChange={(e: any) => {
          handleEditModal({
            ...editModal,
            pricePerQuantity: +e.target.value || 0,
            totalPrice: +e.target.value * editModal.quantity || 0,
          });
        }}
        fullWidth
        style={{ marginTop: 30 }}
      />
      <TextField
        type="number"
        size="small"
        name="totalPrice"
        label={Vocabulary.totalPrice}
        value={editModal.totalPrice}
        onChange={(e: any) => {
          handleEditModal({ ...editModal, totalPrice: +e.target.value || 0 });
        }}
        fullWidth
        style={{ marginTop: 30 }}
      />
    </GenericModal>
  );
}
